// LayoutでlocalStorageに格納しているロジックを退避
import { Routes } from "../../../utils/constants";
import { useLocation } from "react-router-dom";
import { useGlobalState } from "../../../contexts/GlobalContext";
import { TRANSITION_SOURCE_CONFIG } from "../../../utils/configs/app";
import { isAdverTimesUrl } from "../../../utils/helpers/string";
import {
  persistBulkDownloadFlag,
  returnToHasBulkDownload,
} from "../../../utils/helpers/function";

// WARNING: そもそもLayoutでリダイレクトのロジックを持つべきはなくて、専用のcontextを作ってそこに持たせるべき
type URLParams = {
  urlParams: {
    returnTo: string | null;
    mailMagId: string | null;
    transitionSource: string | null;
    surveyId: string | null;
    bulkDownload?: string | null;
  }
}
export const useLayoutStorage = () => {
  const location = useLocation();
  const { globalState } = useGlobalState();
  const { isAuthenticated } = globalState;
  const isOnUserSettingPage = location.pathname === "/user/setting" || location.pathname === "/user/setting/confirm";

  const setLocalStorage = (params: URLParams) => {
    const { urlParams } = params;
    const { returnTo, mailMagId, transitionSource, surveyId, bulkDownload } = urlParams;

    if (mailMagId) {
      localStorage.setItem("mailmagid", mailMagId);
    }
    if (returnTo && !isOnUserSettingPage) {
      localStorage.setItem("loginCallBackUrl", returnTo);
    }

    if (surveyId && location.pathname === Routes.USERGUEST && !isAuthenticated) {
      const isGoogleLogin = localStorage.getItem("isGoogleLogin");
      const existingTrackingRoute = localStorage.getItem("trackingInflowRoute");
      // Preserve returnto so OAuth / multi-step login can still return to AdverTimes (SDK_WEB-1374)
      const existingLoginCallBackUrl =
        returnTo || localStorage.getItem("loginCallBackUrl");
      const existingBulkDownload = localStorage.getItem("bulkDownload");
      localStorage.clear();
      localStorage.setItem("surveyId", surveyId);
      localStorage.setItem("isGoogleLogin", isGoogleLogin ?? "");
      if (existingTrackingRoute) {
        localStorage.setItem("trackingInflowRoute", existingTrackingRoute);
      }
      if (existingLoginCallBackUrl) {
        localStorage.setItem("loginCallBackUrl", existingLoginCallBackUrl);
      }
      if (existingBulkDownload === "true") {
        persistBulkDownloadFlag(true);
      }
    }

    if (!transitionSource && isAdverTimesUrl(returnTo)) {
      localStorage.setItem(
        "transition_source",
        TRANSITION_SOURCE_CONFIG.ADTAI.value
      );
    }

    persistBulkDownloadFlag(
      bulkDownload === "true" || returnToHasBulkDownload(returnTo)
    );

    if (transitionSource) {
      localStorage.setItem("transition_source", transitionSource);
    }

    if (!isAuthenticated) {
      const fullUrl = location.pathname + location.search;
      if (location.pathname.startsWith("/user/survey/answer/")) {
        localStorage.setItem("survey_url", fullUrl);
      }
      if (location.pathname.startsWith("/survey/member")) {
        localStorage.setItem("survey_url", fullUrl);
      }
      if (location.pathname.startsWith("/user/setting")) {
        localStorage.setItem("serviceid_url", fullUrl);
      }
      if (location.pathname.startsWith("/email/change")) {
        localStorage.setItem("email_change", fullUrl);
      }
    }
  }

  return { setLocalStorage };
}
